import { h } from 'preact'
import Button from '../../control-components/ui-components/Button'
import Icon from '../assets'
import Portal from 'preact-portal'
import Phrase from '../../libs/translationsUtils/phrase'
import Dropdown, {
  DropdownItem
} from '../design-system-components/dropdown/index'
import classnames from 'classnames'

interface Props {
  joinGroup: () => void
  leaveGroup: () => void
  subscribe: () => void
  unsubscribe: () => void
  isLoading: boolean
  isUserSubscribed: boolean
  isUserMember: boolean
  groupId: number
}

const GroupActionButtons = ({ joinGroup, isLoading, isUserMember, groupId, isUserSubscribed, unsubscribe, subscribe, leaveGroup }: Props) => (
  <Portal key='new-button' into='.group-details-page_action-buttons'>
    {
        isUserMember
          ? (
            <div className='group-details_hero__user-actions'>
              <Dropdown
                size='S'
                align='right'
                popupName='group-actions-list'
                trigger={<Button
                  type='button'
                  className={classnames('btn', 'btn--secondary', 'group-details_hero__user-action-dropdown-btn')}
                         ><Phrase p='groups.you.are.member' /><Icon customClass='icon-dropdown' width={24} icon='chevronDown' /></Button>}
              >
                <DropdownItem>
                  {
                        isUserSubscribed
                          ? (
                            <span className='user-action__group-subscription-btn' onClick={unsubscribe}><Phrase p='groups.unsubscribe.from.notifications' /></span>
                            )
                          : <span className='user-action__group-subscription-btn' onClick={subscribe}><Phrase p='groups.subscribe.to.notifications' /></span>
                      }
                </DropdownItem>
                <DropdownItem type='alert'>
                  <div className='user-action__leave-group-btn' onClick={leaveGroup}><Phrase p='groups.leave.group' /></div>
                </DropdownItem>
              </Dropdown>

              <a
                type='button'
                className={classnames('btn--cta', 'create-group-topic-btn', 'is-hidden-S')}
                href={`/topic/new?fid=${groupId}`}
              ><Phrase p='main.navigation.add_topic' /></a>
            </div>
            )
          : (
            <Button
              type='button'
              className='btn--cta'
              loading={isLoading}
              onClick={joinGroup}
            ><Phrase p='groups.join.group' /></Button>
            )
      }

  </Portal>
)

export default GroupActionButtons
